/**
 * Normalize reaction API / article fields into a consistent patch.
 */
export function reactionPatchFromResponse(res = {}) {
  const myReaction =
    res.myReaction ??
    (res.likedByMe || res.liked ? '👍' : null) ??
    null;
  const reactions = res.reactions ?? {};
  const likeCount =
    res.likeCount ??
    res.reactionTotal ??
    Object.values(reactions).reduce((sum, n) => sum + (Number(n) || 0), 0);
  return {
    myReaction: myReaction || null,
    reactions,
    reactionTotal: res.reactionTotal ?? likeCount,
    likeCount,
    likedByMe: res.likedByMe === true || res.liked === true || myReaction === '👍',
  };
}

export function viewerReactionFromArticle(article) {
  if (!article) return null;
  if (article.myReaction) return article.myReaction;
  if (article.likedByMe) return '👍';
  return null;
}

/** Patch every cached feed page that contains this article. */
export function patchFeedCaches(queryClient, articleId, patch) {
  queryClient.setQueriesData({ queryKey: ['pages', 'feed'] }, (current) => {
    if (!current?.pages) return current;
    return {
      ...current,
      pages: current.pages.map((page) => ({
        ...page,
        items: (page.items ?? []).map((article) =>
          article.id === articleId ? { ...article, ...patch } : article,
        ),
      })),
    };
  });
}

/** Patch a single article detail cache (pages.article shape). */
export function patchArticleCache(queryClient, articleId, patch) {
  queryClient.setQueriesData(
    { queryKey: ['pages', 'article', articleId] },
    (prev) => {
      if (!prev?.article) return prev;
      return {
        ...prev,
        article: {
          ...prev.article,
          ...patch,
        },
      };
    },
  );
}

/** Keep feed list + article detail in sync after a like/reaction. */
export function syncArticleReactionCaches(queryClient, articleId, res) {
  const patch = reactionPatchFromResponse(res);
  patchFeedCaches(queryClient, articleId, patch);
  patchArticleCache(queryClient, articleId, patch);
  return patch;
}

/** Patch shareCount after a successful share. */
export function syncArticleShareCaches(queryClient, articleId, shareCount) {
  const patch = { shareCount: Number(shareCount) || 0 };
  patchFeedCaches(queryClient, articleId, patch);
  patchArticleCache(queryClient, articleId, patch);
  return patch;
}
